module.exports = __webpack_public_path__ + "media/images/best answer-050086fe9b798355c995cbc53564c570.svg";